import React from 'react'


import '../../../styles/About/Route/Graduation.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'

const Graduation = () => {
    return (
        <>
            <div className="graduation">
                <div className="graduation__container">
                    <div className="graduation__header">
                        <h2 className="graduation__number">0<span>4</span></h2>
                        <h1 data-aos='fade-down' data-aos-offset="0">E<span>ngineering</span>.</h1>
                    </div>

                    <div className="graduation__description">
                        <h1>College-</h1>
                        <h2><FontAwesomeIcon icon={faCalendarDays} className="internships__calendar" />&nbsp;&nbsp;01/08/2016 - 31/07/2020</h2>
                        <p>Rajarshi Rananjay Sinh Institute of Management and Technology, Sultanpur, Uttar Pradesh.</p><br/>

                        <h1>University-</h1>
                        <h2><FontAwesomeIcon icon={faCalendarDays} className="internships__calendar" />&nbsp;&nbsp;01/08/2016 - 31/07/2020</h2>
                        <p>Dr. A.P.J. Abdul Kalam Technical University, Lucknow, Uttar Pradesh.</p>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Graduation